import { ArrayHelpers, Loading, Modal, SystemText, Table } from 'e4shared';
import { ratingColour } from 'helpers/metrics';
import React from 'react';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';

export const Affected = ({ show, widget, onClose }) => {
    const [loading, setLoading] = React.useState(false);
    const [descending, setDescending] = React.useState(false);
    const [sortBy, setSortBy] = React.useState('list_Name');
    const [page, setPage] = React.useState(1);
    const [data, setData] = React.useState([]);
    const [sortedData, setSortedData] = React.useState([]);

    const { user } = useSelector(state => state.user);

    const pageSize = 10;

    React.useEffect(() => {
        if (show?.id) {
            setLoading(true);
            apiGet(`users-affected/${widget}/${show.id}`, user.guid, response => {
                setData(response);
                setLoading(false);
            });
        }
    }, [show?.id]);

    React.useEffect(() => {
        if (data?.length) {
            const d = descending ? -1 : 1;
            setSortedData(
                ArrayHelpers.getPage(
                    data.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 * d : -1 * d)),
                    page,
                    pageSize
                )
            );
        }
    }, [data, page, sortBy, descending]);

    const columns = [
        {
            label: SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Affected/Modal/Table/Name'),
            dataProperty: 'list_Name',
            format: (value, row) => <span className="mr5">{row.full_Name}</span>,
        },
        {
            label: SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Affected/Modal/Table/Role'),
            dataProperty: 'roles',
            format: (value, row) => (
                <>{!value?.length ? '-' : value.length === 1 ? value[0] : `${value[0]} (+${value.length - 1})`}</>
            ),
        },
        {
            label: SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Affected/Modal/Table/Location'),
            dataProperty: 'locations',
            format: (value, row) => (
                <>{!value?.length ? '-' : value.length === 1 ? value[0] : `${value[0]} (+${value.length - 1})`}</>
            ),
        },
        {
            label: SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Affected/Modal/Table/Rating'),
            dataProperty: 'rating',
            format: (value, row) => <label className={`label label-${ratingColour(value)}`}>{value || '-'}</label>,
        },
        {
            label: SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Affected/Modal/Table/Manager'),
            dataProperty: 'managerRating',
            format: (value, row) => (value ? value?.toFixed(1) : '-'),
        },
    ];

    const options = {
        sortBy,
        ascending: !descending,
        page,
        pageSize: pageSize,
        recordCount: data.length,
    };

    return (
        <Modal
            show={show}
            title={SystemText(
                'Dashboard/Widgets/ActionPlanner/Table/Columns/Affected/Modal/Title',
                show?.name,
                show?.impacted
            )}
            footer={null}
            close={onClose}
        >
            {loading ? (
                <Loading />
            ) : (
                <Table
                    data={sortedData}
                    columns={columns}
                    options={options}
                    sort={column => {
                        if (column === sortBy) {
                            setDescending(!descending);
                        }

                        setSortBy(column);
                    }}
                    goToPage={setPage}
                />
            )}
        </Modal>
    );
};

export default Affected;
